// models
import { Base } from 'app/shared/models/base.model';
import { Standard } from 'app/standards/shared/standard.model';
import { Supplier } from 'app/shared/models/supplier.model';

export class StandardCalibration extends Base {

  constructor(
    public CertificateCode?: string,
    public Date?: Date,
    public Laboratory?: Supplier,
    public Standard?: Standard
  ) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/standards/shared/standard-calibration.model.ts